import { FormEvent, SetStateAction } from "react"
import classNames from "classnames"

import {
  allContractorSubscriptionPlanOptions,
  contractorSubscriptionNewOptions,
  contractorSubscriptionPlanOptions,
} from "constants/SelectFieldOptions"
import { UITypes } from "types"
import SubscriptionPlan from "types/enums/SubscriptionPlan"

import ModalSectionTitle from "components/common/ModalSectionTitle/ModalSectionTitle"
import { InputNew } from "components/form/InputNew"
import { SelectStatic } from "components/form/SelectStatic"
import { ToggleButton } from "components/form/ToggleButton"

import styles from "./index.module.scss"

interface Props {
  inputValues: UITypes.Contractor
  isCreate?: boolean
  onInputChange: (event: FormEvent<HTMLInputElement>) => void
  setInputValues: (value: SetStateAction<UITypes.Contractor>) => void
}

const SubscriptionSection = ({ inputValues, isCreate, onInputChange, setInputValues }: Props) => {
  const currentPlan =
    allContractorSubscriptionPlanOptions.find(option => option.value === inputValues.subscriptionPlan) ||
    allContractorSubscriptionPlanOptions[0]

  const handleChange = (values: UITypes.Option[]) => {
    if (!values.length) return

    setInputValues(prevState => {
      return { ...prevState, subscriptionPlan: values[0]?.value as SubscriptionPlan }
    })
  }

  return (
    <div>
      <ModalSectionTitle title="Subscription plan" />
      <div className={classNames(styles.row, styles.subscriptionRow)}>
        <div className={styles.subscriptionPlanName}>
          <div>{currentPlan?.label}</div>
          <div>Monthly</div>
        </div>
        <div className={styles.subscriptionDropdownContainer}>
          <SelectStatic
            placeholder="Select subscription plan"
            values={[currentPlan]}
            options={isCreate ? contractorSubscriptionNewOptions : contractorSubscriptionPlanOptions}
            onChange={handleChange}
            contentRenderer={() => <>Change plan</>}
            backspaceDelete={false}
            menuClassName={styles.subscriptionSelectMenu}
            isSearchable={false}
          />
        </div>
      </div>
      <div className={styles.row}>
        <InputNew
          label="Stripe Customer ID"
          placeholder="Enter Stripe Customer ID"
          name="stripeCustomerId"
          value={inputValues.stripeCustomerId}
          className={styles.inputText}
          onChange={onInputChange}
        />
        <InputNew
          label="HubSpot Deal ID"
          placeholder="Enter HubSpot Deal ID"
          name="hubspotDealId"
          value={inputValues.hubspotDealId}
          className={styles.inputText}
          onChange={onInputChange}
        />
      </div>
      {!isCreate && (
        <>
          <div className={classNames(styles.row, styles.subscriptionRow)}>
            <div className={classNames(styles.modalLine, styles.subscriptionSectionModalLine)}></div>
          </div>
          <div className={styles.row}>
            <div className={styles.toggleFieldWrapper}>
              <ToggleButton id="isDisable" name="isDisable" isChecked={inputValues.isDisable} onChange={onInputChange}>
                Disable contractor
              </ToggleButton>
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default SubscriptionSection
